import request from '@/utils/request'

// 列表接口
export const getAntSmsAccount = (params: any) => request({
  url: 'manage/ant-sms-account',
  method: 'get',
  params
})

// 新增列表接口
export const addAntSmsAccount = (data: any) => request({
  url: 'manage/ant-sms-account',
  method: 'post',
  data: data
})

// 删除接口
export const deleteAntSmsAccount = (data: any) => request({
  url: 'manage/ant-sms-account/' + data,
  method: 'delete'
})

// 更新接口
export const editWallet = (data: any) => request({
  url: 'manage/ant-sms-account/' + data.id,
  method: 'patch',
  data
})

// 蚂蚁短信日志-列表接口
export const getAntSmsLog = (params: any) => request({
  url: 'manage/ant-sms-log',
  method: 'get',
  params
})
